// extracted by mini-css-extract-plugin
export default {"userTag":"s_userTag__uSt4N","userInfo":"s_userInfo__moU0F","white":"s_white__B6pLk","black":"s_black__zgDmT"};